/**
 * Column picker for Search Terms and Negatives (ТЗ «перевод в Ads Manager»
 * §7.1). These grids have a fixed layout, so the picker lists only the columns
 * that can be switched off — today just Translation. Same trigger and popup as
 * the rest of the Ads Manager toolbar.
 */

import { SimpleDropdown } from "@/components/SimpleDropdown";

export function GridColumnsMenu({
  columns,
  visible,
  onToggle,
}: {
  columns: { key: string; label: string }[];
  visible: (key: string) => boolean;
  onToggle: (key: string) => void;
}) {
  return (
    <SimpleDropdown
      label="Columns"
      width={180}
      items={columns.map((c) => ({
        value: c.key,
        label: `${visible(c.key) ? "✓" : " "} ${c.label}`,
      }))}
      onPick={onToggle}
    />
  );
}
